import { StoreProvider } from '@store/StoreProvider'
import ReactDOM from 'react-dom/client'
import React from 'react'
import App from '@app/App'
import '@app/index.css'
import { BrowserRouter } from 'react-router-dom'
import { initChatxOpenButtons } from '@utils/openSiteWidget'
import { appOrigin, isStatusHost } from '@utils/appDomain'
import { installAuthFetchInterceptor } from '@utils/authFetch'

initChatxOpenButtons()
// Access-token refresh (cookie-based) for every API call — before the first fetch.
installAuthFetchInterceptor()

// Pages are separate files with hashed names. After a deploy the old files are gone, so a tab
// opened before it fails to load the next page: reload once to pick up the new build
// (guarded — never more than one reload per 10 s, so a real outage cannot loop).
window.addEventListener('vite:preloadError', (event) => {
  const key = 'chatx_chunk_reload_at'
  try {
    const last = Number(sessionStorage.getItem(key) || 0)
    if (Date.now() - last < 10_000) return
    sessionStorage.setItem(key, String(Date.now()))
  } catch {
    return
  }
  event.preventDefault()
  window.location.reload()
})

const { pathname, search, hash } = window.location

if (isStatusHost() && !['/', '/status', '/status/'].includes(pathname)) {
  window.location.replace(`${appOrigin()}${pathname}${search}${hash}`)
} else {
  initChatxOpenButtons()

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <StoreProvider>
          <App />
        </StoreProvider>
      </BrowserRouter>
    </React.StrictMode>,
  )
}
